module.exports = __webpack_public_path__ + "Roboto-500.f1d811cdfaea49c96950.svg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.svg
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.svg
// module chunks = main styles